import { useQuery } from "@tanstack/react-query";
import { Watchlists } from "@graylog/enterprise-api";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
import { defaultOnError } from "util/conditional/onError";
const API_PREFIX = "/plugins/org.graylog.plugins.watchlist/v2/watchlists";
export const fetchWatchlists = () => Watchlists.list();
export const bulkCheckWatchlists = (checks) => fetch("POST", qualifyUrl(`${API_PREFIX}/bulk-check`), { checks });
export const fetchWatchlist = (id) => Watchlists.get(id);
export const fetchWatchlistEntries = (id, { page, perPage, query, sort, order }) => {
  const url = PaginationURL(`${API_PREFIX}/${id}/entries/paginated`, page, perPage, query, { sort, order });
  return fetch("GET", qualifyUrl(url));
};
export const addWatchlistEntries = (id, values, ttlSeconds) => Watchlists.addEntries(id, { values, ttl_seconds: ttlSeconds != null ? ttlSeconds : null });
export const validateWatchlistEntries = (type, values) => fetch("POST", qualifyUrl(`${API_PREFIX}/validate-entries`), { type, values });
export const removeWatchlistEntries = (id, values) => Watchlists.removeEntries(id, { values });
export const setWatchlistDefaultTtl = (id, seconds) => Watchlists.setDefaultTtl(id, seconds);
export const useWatchlist = (id) => useQuery({
  queryKey: ["watchlists", "v2", id],
  queryFn: () => defaultOnError(fetchWatchlist(id), "Loading watchlist failed with status")
});
export const useWatchlistEntries = (id, params) => useQuery({
  queryKey: ["watchlists", "v2", id, "entries", params],
  queryFn: () => defaultOnError(fetchWatchlistEntries(id, params), "Loading watchlist entries failed with status")
});
export const resolveWatchlistIdByType = async (type) => {
  const watchlists = await fetchWatchlists();
  const match = watchlists.find((watchlist) => watchlist.type === type);
  if (!match) {
    throw new Error(`No watchlist found for type "${type}"`);
  }
  return match.id;
};
const useWatchlistsV2 = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["watchlists", "v2", "all"],
    queryFn: () => defaultOnError(fetchWatchlists(), "Loading watchlists failed with status")
  });
  return { watchlists: data != null ? data : [], isLoading, error };
};
export default useWatchlistsV2;
